// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"61720f99","410":"8f76b24e","488":"96869f9c","661":"687e7dce"}[chunkId] + ".chunk.js";
};